import React from "react";
import { Link } from "react-router-dom";
import RoutingPaths from "../../utils/RoutingPaths";
import { copyRight } from "../../utils/HelperFunctions";

export default function Footer() {
  return (
    <footer className="footerX">
      <div className="footer-left">{copyRight()}</div>

      <div className="footer-right">
        <Link to={RoutingPaths.TERMS_AND_CONDITIONS}>Terms and conditions</Link>
        <Link to={RoutingPaths.PRIVACY_POLICY}>Privacy policy</Link>
      </div>
    </footer>
  );
}
